'use strict';

angular.module('cloudBillingLegacyFrontend').controller('ModalTenantSettingsCtrl', function($scope, $modalInstance, TenantSettings) {
    
    $scope.tenantProfileForm = TenantSettings;

    $scope.updateProfile = function() {
      $modalInstance.close({tenantSettings: $scope.tenantProfileForm});
    };

    $scope.cancel = function () {
        $modalInstance.dismiss("cancel")
    };  

    $scope.deleteLink = function () {
      var deleteOk = confirm("Do you really want to remove the directory link? This connection can't be established again!");

      if (deleteOk) {
        $modalInstance.close({tenantSettings: $scope.tenantProfileForm, deleteLink: true});
      }
  };  
});



